// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { EmptyView } from 'common/components/EmptyView/EmptyView';
import { NotFoundSvg } from 'common/components/ErrorPages/Styles';

export const AccessForbidden: React.FC = () => (
    <EmptyView
        title="errorPages.accessForbidden.title"
        description="errorPages.accessForbidden.description"
        customIcon={<NotFoundSvg />}
    />
);

export default AccessForbidden;